import { create } from "zustand";
import { default_sales_page_template_tab } from "../constants/SalesPages.constants";

export const useSalesPageStore = create((set) => ({
  selectedTemplateDetails: {},
  setSelectedTemplateDetails: (value) =>
    set({ selectedTemplateDetails: value }),
  selectedTab: default_sales_page_template_tab,
  setSelectedTab: (value) => set({ selectedTab: value }),
}));
